"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _shader = _interopRequireDefault(require("./shader"));
var redBase = '#D12222';
var red = {
  dark40: (0, _shader["default"])(-0.4, redBase),
  //#220505
  dark30: (0, _shader["default"])(-0.3, redBase),
  //#4D0D0D
  dark20: (0, _shader["default"])(-0.2, redBase),
  //#791414
  dark10: (0, _shader["default"])(-0.1, redBase),
  //#A51B1B
  base: redBase,
  light10: (0, _shader["default"])(0.1, redBase),
  //#E14545
  light20: (0, _shader["default"])(0.2, redBase),
  //#E87171
  light30: (0, _shader["default"])(0.3, redBase),
  //#EF9D9D
  light40: (0, _shader["default"])(0.4, redBase),
  //#F6C9C9
  light45: (0, _shader["default"])(0.45, redBase) //#FADFDF
};
var _default = red;
exports["default"] = _default;